// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2lzem","label":"Section_label__2PbL5","contentWrap":"Section_contentWrap__12Qlt","footer":"Section_footer__3toFd","footerInner":"Section_footerInner__38qZp"};